$(document).on('click', '.btn-add-free-item', function(){
    $(this).attr('disabled', true);
    var _this = this;
    $(this).append('<i class="fa fa-spin fa-circle-o-notch"></i>');
    const data = {
        variationId : $(this).data('variationid'),
        quantity    : 1,
        basketItemOrderParams: [{
            propertyId: $(this).data('propertieid'),
            type: 'empty',
            name: 'Ja',
            value: true
        }],
        totalOrderParamsMarkup: 0,
        template: 'Ceres::Basket.Basket'
    };

    vueApp.$store.commit("setIsAddToBasketLoading", 1019);
    //vueApp.$store.dispatch('loadComponent', 'basket-preview');
    vueApp.$store.dispatch("addBasketItem", data).then(
        response =>
            {
                $(_this).removeAttr('disabled');
                $(this).find('.fa-spin').remove();
            },
            error =>
            {
                $(_this).removeAttr('disabled');
                $(this).find('.fa-spin').remove();
            }
    );
})